import dhtmlXGridObject from './dhtmlXGridObject';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';
import {_isFF} from '../../global/commonUtils';
import dhtmlxArray from './dhtmlxArray';
import {globalObj} from './dxGridComClass';

dhtmlXGridObject.prototype._groups_get = function () {
    var c = [];
    this._temp_par = this.obj.parentNode;
    this._temp_par.removeChild(this.obj);
    var e = [];
    for (var g = this.rowsCol.length - 1; g >= 0; g--) {
        if (this.rowsCol[g]._cntr) {
            this.rowsCol[g]._cntr._childs = e;
            e = [];
            c.push(this.rowsCol[g]);
        }
        else {
            e.push(this.rowsCol[g]);
        }
        this.rowsCol[g].parentNode.removeChild(this.rowsCol[g]);
    }
    return c;
};
dhtmlXGridObject.prototype._groups_put = function (a) {
    var h = this.rowsCol.stablesort;
    this.rowsCol = new dhtmlxArray(0);
    this.rowsCol.stablesort = h;
    for (var g = 0; g < a.length; g++) {
        var e = a[g]._cntr;
        this.obj.firstChild.appendChild(e.row);
        this.rowsCol.push(e.row);
        e.row.idd = null;
        for (var c = 0; c < e._childs.length; c++) {
            this.obj.firstChild.appendChild(e._childs[c]);
            this.rowsCol.push(e._childs[c]);
        }
        delete e._childs;
    }
    this._temp_par.appendChild(this.obj);
};
dhtmlXGridObject.prototype._groupExisting = function () {
    if (!this.getRowsNum()) {
        return;
    }
    var c = [];
    this._temp_par = this.obj.parentNode;
    this._temp_par.removeChild(this.obj);
    var e = [];
    var g = this.rowsCol.length;
    for (var h = 0; h < g; h++) {
        var m = this.cells4(this.rowsCol[h].childNodes[this._gIndex]).getValue();
        this.rowsCol[h].style.display = "";
        if (!m) {
            m = " ";
        }
        if (!this._groups[m]) {
            this._groups[m] = {
                text: m,
                row: this._addPseudoRow(true),
                count: 0,
                state: "minus"
            };
            var l = this._groups[m];
            l.row._cntr = l;
            this._groups[m]._childs = [];
            c.push(l.row);
        }
        this._groups[m].count++;
        this._groups[m]._childs.push(this.rowsCol[h]);
        this.rowsCol[h].parentNode.removeChild(this.rowsCol[h]);
    }
    for (var h_1 = 0; h_1 < c.length; h_1++) {
        this._updateGroupView(c[h_1]._cntr);
    }
    this._groups_put(c);
    if (this._fake && !this._realfake) {
        this._mirror_rowsCol();
        this._fake._groups = [];
        this._fake._reset_view();
    }
    this.callEvent("onGridReconstructed", []);
    this.updateGroups();
};
dhtmlXGridObject.prototype._switchGroupState = function (g) {
    var e = g._cntr;
    if (this._fake && !this._realfake) {
        e.state = this._fake._groups[g._cntr.text].row._cntr.state;
        this._fake._switchGroupState(this._fake._groups[g._cntr.text].row);
    }
    var c = this.rowsCol._dhx_find(e.row) + 1;
    e.state = e.state == "minus" ? "plus" : "minus";
    var a = e.state == "plus" ? "none" : "";
    while (this.rowsCol[c] && !this.rowsCol[c]._cntr) {
        this.rowsCol[c].style.display = a;
        c++;
    }
    this._updateGroupView(e);
    this.callEvent("onGroupStateChanged", [e.text, e.state == "minus"]);
    this.setSizes();
};
dhtmlXGridObject.prototype.expandGroup = function (a) {
    if (this._groups[a].state == "plus") {
        this._switchGroupState(this._groups[a].row);
    }
};
dhtmlXGridObject.prototype.collapseGroup = function (a) {
    if (this._groups[a].state == "minus") {
        this._switchGroupState(this._groups[a].row);
    }
};
dhtmlXGridObject.prototype.expandAllGroups = function () {
    for (var a in this._groups) {
        if (this._groups[a] && this._groups[a].state == "plus") {
            this._switchGroupState(this._groups[a].row);
        }
    }
};
dhtmlXGridObject.prototype.collapseAllGroups = function () {
    for (var a in this._groups) {
        if (this._groups[a] && this._groups[a].state == "minus") {
            this._switchGroupState(this._groups[a].row);
        }
    }
};
dhtmlXGridObject.prototype.hideGroupColumn = function (l, h) {
    if (this._fake) {
        return;
    }
    var g = -1;
    var m = this._gmask.childNodes;
    for (var e = 0; e < m.length; e++) {
        if (m[e]._cellIndex == l) {
            g = e;
            break;
        }
    }
    if (g == -1) {
        return;
    }
    for (var c in this._groups) {
        this._groups[c].row.childNodes[g].style.display = h ? "none" : "";
    }
};
dhtmlXGridObject.prototype.groupStat = function (c, g, e) {
    e = this["_g_" + (e || "stat_total")];
    var h = 0;
    var a = 0;
    this.forEachRowInGroup(c, function (l) {

        h = e(h, this.cells(l, g).getValue() * 1, a);
        a++;
    });
    return h;
};
dhtmlXGridObject.prototype.forEachRowInGroup = function (a, g) {
    var h = this._groups[a].row.nextSibling;
    if (h) {
        while (h && !h._cntr) {
            g.call(this, h.idd);
            h = h.nextSibling;
        }
    }
    else {
        var e = this._groups[a]._childs;
        if (e) {
            for (var c = 0; c < e.length; c++) {
                g.call(this, e[c].idd);
            }
        }
    }
};
dhtmlXGridObject.prototype.updateGroups = function () {
    if (!this._gmask || !this._gmask._math || this._parsing) {
        return;
    }
    var c = this._gmask.childNodes;
    for (var a = 0; a < c.length; a++) {
        if (c[a]._counter) {
            this._b_processing.apply(this, c[a]._counter);
        }
    }
};
dhtmlXGridObject.prototype._b_processing = function (e, m, l) {
    var n = 0, g = 0;
    if (!this._ecache[this.cellType[m]]) {
        this.cells5({ parentNode: { grid: this } }, this.cellType[m]);
    }
    for (var h = this.rowsCol.length - 1; h >= 0; h--) {
        if (!this.rowsCol[h]._cntr) {
            n = e(n, this.cells3(this.rowsCol[h], m).getValue() * 1, g);
            g++;
        }
        else {
            this.cells5(this.rowsCol[h].childNodes[l], this.cellType[m]).setValue(n);
            g = n = 0;
        }
    }
};
dhtmlXGridObject.prototype._g_stat_total = function (g, e, a) {
    return g + e;
};
dhtmlXGridObject.prototype._g_stat_min = function (g, e, a) {
    if (!a) {
        g = Infinity;
    }
    return Math.min(g, e);
};
dhtmlXGridObject.prototype._g_stat_max = function (g, e, a) {
    if (!a) {
        g = -Infinity;
    }
    return Math.max(g, e);
};
dhtmlXGridObject.prototype._g_stat_average = function (g, e, a) {
    return (g * a + e) / (a + 1);
};
dhtmlXGridObject.prototype._g_stat_count = function (g, e, a) {
    return ++g;
};
dhtmlXGridObject.prototype._in_header_collapse = function (h, g, n) {
    var a = h.tagName == "TD" ? h : h.parentNode;
    g = a._cellIndexS;
    if (!this._column_groups) {
        this._column_groups = [];
    }
    var m = n[1].split(":");
    m = [m.shift(), m.join(":")];
    var l = parseInt(m[0]);
    h.innerHTML =
        n[0] +
            "<img src='" +
            this.imgURL +
            "minus.gif' style='padding-right:10px;height:16px'/><span style='position:relative; top:-6px;'>" +
            (m[1] || "") +
            "<span>";
    h.style.paddingBottom = "0px";
    var e = this;
    this._column_groups[g] = h.getElementsByTagName("IMG")[0];
    this._column_groups[g].onclick = function (o) {
        (o || event).cancelBubble = true;
        this._cstate = !this._cstate;
        for (var c = g + 1; c < g + l; c++) {
            e.setColumnHidden(c, this._cstate);
        }
        if (this._cstate) {
            if (a.colSpan && a.colSpan > 0) {
                a._exp_colspan = a.colSpan;
                var u = Math.max(1, a.colSpan - l);
                if (!_isFF) {
                    for (var r = 0; r < a.colSpan - u; r++) {
                        var s = document.createElement("TD");
                        if (a.nextSibling) {
                            a.parentNode.insertBefore(s, a.nextSibling);
                        }
                        else {
                            a.parentNode.appendChild(s);
                        }
                    }
                }
                a.colSpan = u;
            }
            e.callEvent("onColumnCollapse", [g, this._cstate]);
        }
        else {
            if (a._exp_colspan) {
                a.colSpan = a._exp_colspan;
                if (!dhx4.isFF) {
                    for (var r_1 = 1; r_1 < a._exp_colspan; r_1++) {
                        a.parentNode.removeChild(a.nextSibling);
                    }
                }
                e.callEvent("onColumnCollapse", [g, this._cstate]);
            }
        }
        this.src = e.imgURL + (this._cstate ? "plus.gif" : "minus.gif");
        if (e.sortImg.style.display != "none") {
            e.setSortImgPos();
        }
    };
};
dhtmlXGridObject.prototype.collapseColumns = function (a) {
    if (!this._column_groups[a] || this._column_groups[a]._cstate) {
        return;
    }
    this._column_groups[a].onclick({});
};
dhtmlXGridObject.prototype.expandColumns = function (a) {
    if (!this._column_groups[a] || !this._column_groups[a]._cstate) {
        return;
    }
    this._column_groups[a].onclick({});
};
dhtmlXGridObject.prototype.enableHeaderMenu = function (a) {
    if (!window.dhtmlXMenuObject) {
        return dhtmlx.message("You need to include DHTMLX Menu");
    }
    if (!this._header_menu) {

        var e = (this._header_menu = new dhtmlXMenuObject());
        e.renderAsContextMenu();
        var c = this;
        e.attachEvent("onBeforeContextMenu", function () {
            c._showHContext(a);
            return true;
        });
        e.attachEvent("onClick", function (r) {

            var m = this.getCheckboxState(r);
            var n = c.hdr.rows[1];
            for (var h = 0; h < n.cells.length; h++) {
                var o = n.cells[h];
                if (o._cellIndexS == r) {
                    var g = o.colSpan || 1;
                    for (var l = 0; l < g; l++) {
                        c.setColumnHidden(r * 1 + l, !m);
                    }
                }
            }
        });
        this.attachEvent("onInit", function () {

            e.addContextZone(this.hdr);
        });
        if (this.hdr.rows.length) {
            this.callEvent("onInit", []);
        }
    }
};
dhtmlXGridObject.prototype.getHeaderMenu = function (a) {
    return this._header_menu;
};
dhtmlXGridObject.prototype._hideHContext = function () {
    if (this._header_menu) {
        this._header_menu.hide();
    }
};
dhtmlXGridObject.prototype._showHContext = function (g) {
    if (typeof g == "string") {
        g = g.split(this.delim);
    }
    var h = 0;
    var a = 0;
    this._header_menu.clearAll();
    for (var e = 0; e < this.hdr.rows[1].cells.length; e++) {
        var n = this.hdr.rows[1].cells[e];
        var m = null;
        if (!g || (g[h] && g[h] != "false")) {
            if (n.firstChild && n.firstChild.tagName == "DIV") {
                m = n.firstChild.innerHTML;
            }
            else {
                m = n.innerHTML;
            }
            m = m.replace(/<[^>]*>/gi, "");
            var l = !(this.isColumnHidden(h) || this.getColWidth(h) == 0);
            this._header_menu.addCheckbox("child", this._header_menu.topId, a, h, m, l);
            a++;
        }
        h += n.colSpan || 1;
    }
};
dhtmlXGridObject.prototype._process_json_row = function (h, l) {
    h._attrs = l;
    for (var e = 0; e < h.childNodes.length; e++) {
        h.childNodes[e]._attrs = {};
    }
    if (l.userdata) {
        for (var c in l.userdata) {
            this.setUserData(h.idd, c, l.userdata[c]);
        }
    }
    l = this._c_order ? this._swapColumns(l.data) : l.data;
    for (var g = 0; g < l.length; g++) {
        if (typeof l[g] == "object" && l[g] != null) {
            h.childNodes[g]._attrs = l[g];
            if (l[g].type) {
                h.childNodes[g]._cellType = l[g].type;
            }
            l[g] = l[g].value;
        }
    }
    this._fillRow(h, l);
    return h;
};
dhtmlXGridObject.prototype._process_js_row = function (l, m) {
    l._attrs = m;
    for (var g = 0; g < l.childNodes.length; g++) {
        l.childNodes[g]._attrs = {};
    }
    if (m.userdata) {
        for (var e in m.userdata) {
            this.setUserData(l.idd, e, m.userdata[e]);
        }
    }
    var c = [];
    for (var h = 0; h < this.columnIds.length; h++) {
        c[h] = m[this.columnIds[h]];
        if (typeof c[h] == "object" && c[h] != null) {
            l.childNodes[h]._attrs = c[h];
            if (c[h].type) {
                l.childNodes[h]._cellType = c[h].type;
            }
            c[h] = c[h].value;
        }
        if (!c[h] && c[h] !== 0) {
            c[h] = "";
        }
    }
    this._fillRow(l, c);
    return l;
};
dhtmlXGridObject.prototype.updateFromJSON = function (a, g, c, e) {
    if (typeof g == "undefined") {
        g = true;
    }
    this._refresh_mode = [true, g, c];
    this.load(a, e, "json");
};
dhtmlXGridObject.prototype._refreshFromJSON = function (e) {
    if (this._f_rowsBuffer) {
        this.filterBy(0, "");
    }
    var reset = false;
    if (window.eXcell_tree) {
        eXcell_tree.prototype.setValueX = eXcell_tree.prototype.setValue;
        eXcell_tree.prototype.setValue = function (u) {
            var s = this.grid._h2.get[this.cell.parentNode.idd];
            if (s && this.cell.parentNode.valTag) {
                this.setLabel(u);
            }
            else {
                this.setValueX(u);
            }
        };
    }
    var r = this.cellType._dhx_find("tree");
    var h = e.parent || 0;
    var m = {};
    if (this._refresh_mode[2]) {
        if (r != -1) {
            this._h2.forEachChild(h, function (s) {
                m[s.id] = true;
            }, this);
        }
        else {
            this.forEachRow(function (s) {
                m[s] = true;
            });
        }
    }
    var o = e.rows;
    for (var g = 0; g < o.length; g++) {
        var n = o[g];
        var a = n.id;
        m[a] = false;
        if (this.rowsAr[a] && this.rowsAr[a].tagName != "TR") {
            if (this._h2) {
                this._h2.get[a].buff.data = n;
            }
            else {
                this.rowsBuffer[this.getRowIndex(a)].data = n;
            }
            this.rowsAr[a] = n;
        }
        else {
            if (this.rowsAr[a]) {
                this._process_json_row(this.rowsAr[a], n, -1);
                this._postRowProcessing(this.rowsAr[a], true);
            }
            else {
                if (this._refresh_mode[1]) {
                    var l = {
                        idd: a,
                        data: n,
                        _parser: this._process_json_row,
                        _locator: this._get_json_data
                    };
                    var c = this.rowsBuffer.length;
                    if (this._refresh_mode[1] == "top") {
                        this.rowsBuffer.unshift(l);
                        c = 0;
                    }
                    else {
                        this.rowsBuffer.push(l);
                    }
                    if (this._h2) {
                        reset = true;
                        this._h2.add(a, h).buff = this.rowsBuffer[this.rowsBuffer.length - 1];
                    }
                    this.rowsAr[a] = n;
                    n = this.render_row(c);
                    this._insertRowAt(n, c ? -1 : 0);
                }
            }
        }
    }
    if (this._refresh_mode[2]) {
        for (a in m) {
            if (m[a] && this.rowsAr[a]) {
                this.deleteRow(a);
            }
        }
    }
    this._refresh_mode = null;
    if (window.eXcell_tree) {
        eXcell_tree.prototype.setValue = eXcell_tree.prototype.setValueX;
    }
    if (reset) {
        this._renderSort();
    }
    if (this._f_rowsBuffer) {
        this._f_rowsBuffer = null;
        this.filterByAll();
    }
};
dhtmlXGridObject.prototype._process_js = function (a) {
    return this._process_json(a, "js");
};
dhtmlXGridObject.prototype._parseHeadJson = function (s) {
    if (!s.head || !s.head.length) {
        return;
    }
    var a = s.head;
    var g = s.settings;
    var m = "setInitWidths";
    var o = false;
    if (g && g.colwidth == "%") {
        m = "setInitWidthsP";
    }
    if (g && g.splitat == "%") {
        o = g.splitat;
    }
    if (this.hdr.rows.length > 0) {
        this.clearAll(true);
    }
    var n = [[], [], [], [], [], [], []];
    var r = ["value", "width", "type", "align", "sort", "hidden", "id"];
    var v = [
        "",
        m,
        "setColTypes",
        "setColAlign",
        "setColSorting",
        "",
        "setColumnIds"
    ];
    for (var l = 0; l < a.length; l++) {
        for (var h = 0; h < r.length; h++) {

            n[h].push(a[l][r[h]]);
        }
    }
    this.setHeader(n[0]);
    for (var l = 0; l < v.length; l++) {
        if (v[l]) {
            this[v[l]](n[l].join(this.delim));
        }
    }
    for (var l = 0; l < a.length; l++) {
        var u = a[l].options;
        if (a[l].options) {
            if (this.cellType[l] == "clist") {
                this.registerCList(l, u);
            }
            else {
                var c = this.getCombo(l);
                for (var h_2 = 0; h_2 < u.length; h_2++) {
                    c.put(u[h_2].id, u[h_2].value);
                }
            }
        }
    }
    this.init();
    var e = n[5].join(this.delim);
    if (this.setColHidden && e.replace(/,/g, "") != "") {
        this.setColHidden(e);
    }
    if (o && this.splitAt) {
        this.splitAt(o);
    }
};
dhtmlXGridObject.prototype._process_json = function (data, mode) {
    this._parsing = true;
    try {
        data = data.responseText || data;
        if (typeof data == "string") {
            eval("dhtmlx.temp=" + data + ";");
            data = dhtmlx.temp;
        }
    }
    catch (e) {
        dhx4.callEvent("onLoadXMLError", [
            "Incorrect JSON",
            data.xmlDoc || data,
            this
        ]);
        data = { rows: [] };
    }
    if (this._refresh_mode) {
        return this._refreshFromJSON(data);
    }
    if (data.head) {
        this._parseHeadJson(data);
    }
    var cr = parseInt(data.pos || 0);
    var total = parseInt(data.total_count || 0);
    var reset = false;
    if (total) {
        if (!this.rowsBuffer[total - 1]) {
            if (this.rowsBuffer.length) {
                reset = true;
            }
            this.rowsBuffer[total - 1] = null;
        }
        if (total < this.rowsBuffer.length) {
            this.rowsBuffer.splice(total, this.rowsBuffer.length - total);
            reset = true;
        }
    }
    var userdata = mode === "js" ? data.userdata : data;
    for (var key in userdata) {
        if (mode === "js" || key != "rows") {
            this.setUserData("", key, userdata[key]);
        }
    }
    if (mode == "js" && data.collections) {
        for (var colkey in data.collections) {
            var index = this.getColIndexById(colkey);
            var colrecs = data.collections[colkey];
            if (index !== window.undefined) {
                if (this.cellType[index] == "clist") {
                    var colplaindata = [];
                    for (var j = 0; j < colrecs.length; j++) {
                        colplaindata.push(colrecs[j].label);
                    }
                    this.registerCList(index, colplaindata);
                }
                else {
                    var combo = this.getCombo(index);
                    for (var j_1 = 0; j_1 < colrecs.length; j_1++) {
                        combo.put(colrecs[j_1].value, colrecs[j_1].label);
                    }
                }
            }
        }
    }
    if (this.isTreeGrid()) {
        return this._process_tree_json(data, null, null, mode);
    }
    if (mode == "js") {
        var id = null;
        if (data.data) {
            data = data.data;
        }
        for (var i = 0; i < data.length; i++) {
            if (this.rowsBuffer[i + cr]) {
                continue;
            }
            var row = data[i];
            id = row.id || i + 1;
            this.rowsBuffer[i + cr] = {
                idd: id,
                data: row,
                _parser: this._process_js_row,
                _locator: this._get_js_data
            };
            this.rowsAr[id] = data[i];
        }
    }
    else {
        for (var i_1 = 0; i_1 < data.rows.length; i_1++) {
            if (this.rowsBuffer[i_1 + cr]) {
                continue;
            }
            id = data.rows[i_1].id;
            this.rowsBuffer[i_1 + cr] = {
                idd: id,
                data: data.rows[i_1],
                _parser: this._process_json_row,
                _locator: this._get_json_data
            };
            this.rowsAr[id] = data.rows[i_1];
        }
    }
    this.callEvent("onDataReady", []);
    if (reset && this._srnd) {
        var h = this.objBox.scrollTop;
        this._reset_view();
        this.objBox.scrollTop = h;
    }
    else {
        this.render_dataset();
    }
    this._parsing = false;
};
dhtmlXGridObject.prototype._get_json_data = function (c, a) {
    if (typeof c.data[a] == "object") {
        return c.data[a].value;
    }
    else {
        return c.data[a];
    }
};
dhtmlXGridObject.prototype._process_tree_json = function (g, h, c, m) {
    this._parsing = true;
    var a = false;
    if (!h) {
        this.render_row = this.render_row_tree;
        a = true;
        h = g;
        c = h.parent || 0;
        if (c == "0") {
            c = 0;
        }
        if (!this._h2) {
            this._h2 = this._createHierarchy();
        }
        if (this._fake) {
            this._fake._h2 = this._h2;
        }
    }
    if (m == "js") {
        if (h.data && !c) {
            g = h.data;
        }
        if (h.rows) {
            h = h.rows;
        }
        var n = null, l = null;
        for (var e = 0; e < h.length; e++) {
            n = h[e].id;
            l = this._h2.add(n, c);
            l.buff = {
                idd: n,
                data: h[e],
                _parser: this._process_js_row,
                _locator: this._get_js_data
            };
            if (h[e].open) {
                l.state = "minus";
            }
            this.rowsAr[n] = l.buff;
            this._process_tree_json(h[e], h[e], n, m);
        }
    }
    else {
        if (h.rows) {
            for (var e_1 = 0; e_1 < h.rows.length; e_1++) {
                n = h.rows[e_1].id;
                l = this._h2.add(n, c);
                l.buff = {
                    idd: n,
                    data: h.rows[e_1],
                    _parser: this._process_json_row,
                    _locator: this._get_json_data
                };
                if (h.rows[e_1].open) {
                    l.state = "minus";
                }
                this.rowsAr[n] = l.buff;
                this._process_tree_json(h.rows[e_1], h.rows[e_1], n, m);
            }
        }
    }
    if (a) {
        if (c != 0) {
            this._h2.change(c, "state", "minus");
        }
        this._updateTGRState(this._h2.get[c]);
        this._h2_to_buff();
        this.callEvent("onDataReady", []);
        if (c != 0 && (this._srnd || this.pagingOn)) {
            this._renderSort();
        }
        else {
            this.render_dataset();
        }
        if (this._slowParse === false) {
            this.forEachRow(function (o) {

                this.render_row_tree(0, o);
            });
        }
        this._parsing = false;
        if (c != 0 && !this._srnd) {
            this.callEvent("onOpenEnd", [c, 1]);
        }
    }
};
dhtmlXGridObject.prototype.enableMarkedCells = function (a) {
    this.markedRowsArr = new dhtmlxArray(0);
    this.markedCellsArr = new Array(0);
    this.lastMarkedRow = null;
    this.lastMarkedColumn = null;
    this.markedCells = true;
    this.lastMarkMethod = 0;
    if (arguments.length > 0) {
        if (!dhx4.s2b(a)) {
            this.markedCells = false;
        }
    }
};
dhtmlXGridObject.prototype.doMark = function (e, m) {
    var l = e.parentNode.idd;
    this.setActive(true);
    if (!l) {
        return;
    }
    this.editStop();
    this.cell = e;
    this.row = e.parentNode;
    var o = e._cellIndex;
    if (!m) {
        m = 0;
    }
    if (m == 0) {
        this.unmarkAll();
    }
    else {
        if (m == 1) {
            if (this.lastMarkedRow) {
                var c = Math.min(this.getRowIndex(l), this.getRowIndex(this.lastMarkedRow));
                var n = Math.max(this.getRowIndex(l), this.getRowIndex(this.lastMarkedRow));
                var a = Math.min(o, this.lastMarkedColumn);
                var r = Math.max(o, this.lastMarkedColumn);
                for (var h = c; h < n + 1; h++) {
                    for (var g = a; g < r + 1; g++) {
                        this.mark(this.getRowId(h), g, true);
                    }
                }
            }
        }
        else {
            if (m == 2) {
                if (this.markedRowsArr._dhx_find(l) != -1) {
                    for (var s = 0; s < this.markedCellsArr[l].length; s++) {
                        if (this.markedCellsArr[l][s] == o) {
                            this.mark(l, o, false);
                            return true;
                        }
                    }
                }
            }
        }
    }
    if (!this.markedCellsArr[l]) {
        this.markedCellsArr[l] = new dhtmlxArray(0);
    }
    if (m != 1) {
        this.mark(l, o);
    }
    this.moveToVisible(this.cells(l, o).cell);
    this.lastMarkedRow = l;
    this.lastMarkedColumn = o;
    this.lastMarkMethod = m;
};
dhtmlXGridObject.prototype.mark = function (e, c, g) {
    if (arguments.length > 2) {
        if (!dhx4.s2b(g)) {
            this.cells(e, c).cell.className = this.cells(e, c).cell.className.replace(/cellselected/g, "");
            if (this.markedRowsArr._dhx_find(e) != -1) {
                var a = this.markedCellsArr[e]._dhx_find(c);
                if (a != -1) {
                    this.markedCellsArr[e]._dhx_removeAt(a);
                    if (this.markedCellsArr[e].length == 0) {
                        this.markedRowsArr._dhx_removeAt(this.markedRowsArr._dhx_find(e));
                    }
                    this.callEvent("onCellUnMarked", [e, c]);
                }
            }
            return true;
        }
    }
    this.cells(e, c).cell.className += " cellselected";
    if (this.markedRowsArr._dhx_find(e) == -1) {
        this.markedRowsArr[this.markedRowsArr.length] = e;
    }
    if (!this.markedCellsArr[e]) {
        this.markedCellsArr[e] = new dhtmlxArray(0);
    }
    if (this.markedCellsArr[e]._dhx_find(c) == -1) {
        this.markedCellsArr[e][this.markedCellsArr[e].length] = c;
        this.callEvent("onCellMarked", [e, c]);
    }
};
dhtmlXGridObject.prototype.unmarkAll = function () {
    if (this.markedRowsArr) {
        for (var a = 0; a < this.markedRowsArr.length; a++) {
            var e = this.markedRowsArr[a];
            if (this.rowsAr[e]) {
                for (var c = 0; c < this.markedCellsArr[e].length; c++) {
                    this.callEvent("onCellUnMarked", [e, this.markedCellsArr[e][c]]);
                    this.cells(e, this.markedCellsArr[e][c]).cell.className = this.cells(e, this.markedCellsArr[e][c]).cell.className.replace(/cellselected/g, "");
                }
            }
        }
        this.markedRowsArr = new dhtmlxArray(0);
        this.markedCellsArr = new Array(0);
    }
    return true;
};
dhtmlXGridObject.prototype.getMarked = function () {
    var e = new Array();
    if (this.markedRowsArr) {
        for (var a = 0; a < this.markedRowsArr.length; a++) {
            var g = this.markedRowsArr[a];
            for (var c = 0; c < this.markedCellsArr[g].length; c++) {
                e[e.length] = [g, this.markedCellsArr[g][c]];
            }
        }
    }
    return e;
};
dhx4.attachEvent("onGridCreated", function (a) {
    a._reset_math();
    a.attachEvent("onClearAll", a._reset_math);
    a.attachEvent("onCellChanged", function (m, l) {

        if (this._mat_links[m]) {

            var c = this._mat_links[m][l];
            if (c) {
                for (var h = 0; h < c.length; h++) {
                    if (c[h].parentNode) {

                        this.cells5(c[h]).setValue(this._calcSCL(c[h]));
                    }
                }
            }
        }

        if (!this._parsing && this._aggregators[l]) {

            var g = this._h2.get[m].parent.id;
            if (g != 0) {

                var e = this.cells(g, l);

                e.setValue(this._calcSCL(e.cell));
            }
        }
    });
    a.attachEvent("onAfterRowDeleted", function (h, e) {
        if (e != 0) {

            if (!this._parsing && this._aggregators.length) {

                for (var g = 0; g < this._aggregators.length; g++) {

                    if (this._aggregators[g]) {

                        var c = this.cells(e, g);

                        c.setValue(this._calcSCL(c.cell));
                    }
                }
            }
        }
        return true;
    });
    a.attachEvent("onXLE", a._refresh_math);
});
dhtmlXGridObject.prototype._reset_math = function () {
    this._mat_links = {};
    this._aggregators = [];
};
dhtmlXGridObject.prototype._refresh_math = function () {
    for (var a = 0; a < this._aggregators.length; a++) {
        if (this._aggregators[a]) {
            this._h2.forEachChild(0, function (e) {
                if (e.childs.length != 0) {

                    var c = this.cells(e.id, a);

                    c.setValue(this._calcSCL(c.cell));
                }
            }, this);
        }
    }
};
dhtmlXGridObject.prototype.refreshMath = function (a) {
    this._mat_links = {};
    for (var c = 0; c < this.getColumnsNum(); c++) {
        if (this.getColType(c) == "math") {
            this.forEachRow(function (g) {

                var e = this.cells(g, c);
                e.setValue(e.cell.original || e.getValue());
            });
        }
    }
};
dhtmlXGridObject.prototype.enableMathSerialization = function (a) {
    this._mathSerialization = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.setMathRound = function (a) {
    this._roundDl = a;
    this._roundD = Math.pow(10, a);
};
dhtmlXGridObject.prototype.enableMathEditing = function (a) {
    this._mathEdit = dhx4.s2b(a);
};
dhtmlXGridObject.prototype._calcSCL = function (cell) {
    if (!cell._code) {
        return this.cells5(cell).getValue();
    }
    try {
        dhtmlx.agrid = this;
        var z = eval(cell._code);
    }
    catch (e) {
        return "#SCL";
    }
    if (this._roundD) {
        var pre = Math.abs(z) < 1 ? "0" : "";
        if (z < 0) {
            pre = "-" + pre;
        }
        z = Math.round(Math.abs(z) * this._roundD).toString();
        if (z == 0) {
            return 0;
        }
        if (this._roundDl > 0) {
            var n = z.length - this._roundDl;
            if (n < 0) {
                z = ("000000000" + z).substring(9 + n);
                n = 0;
            }
            return pre + z.substring(0, n) + "." + z.substring(n, z.length);
        }
        return pre + z;
    }
    return z;
};
dhtmlXGridObject.prototype._countTotal = function (l, c) {
    var a = 0;
    var h = this._h2.get[l];
    for (var e = 0; e < h.childs.length; e++) {
        if (!h.childs[e].buff) {
            return a;
        }
        if (h.childs[e].buff._parser) {
            a = 0;
            this._h2.forEachChild(l, function (m) {
                if (m.childs.length == 0) {

                    var n = parseFloat(this._get_cell_value(m.buff, c) + "");
                    if (n) {
                        a += n;
                    }
                }
            }, this);
            return a;
        }
        var g = parseFloat(this._get_cell_value(h.childs[e].buff, c) + "");
        if (g) {
            a += g;
        }
    }
    return a;
};
dhtmlXGridObject.prototype._compileSCL = function (e, c, a) {
    if (e === null || e === window.undefined) {
        return e;
    }
    e = e.toString();
    if (e.indexOf("=") != 0 || !c.parentNode) {
        this._reLink([], c);
        if (a) {
            c._code = c.original = null;
        }
        return e;
    }
    c.original = e;
    var l = null;
    e = e.replace("=", "");
    if (e.indexOf("sum") != -1) {
        e = e.replace("sum", "(dhtmlx.agrid._countTotal('" +
            c.parentNode.idd +
            "'," +
            c._cellIndex +
            "))");
        if (!this._aggregators) {
            this._aggregators = [];
        }
        this._aggregators[c._cellIndex] = "sum";
        c._code = e;
        return this._parsing ? "" : this._calcSCL(c);
    }
    var h = null;
    var g = null;
    if (e.indexOf("[[") != -1) {
        h = /(\[\[([^\,]*)\,([^\]]*)]\])/g;
        dhtmlx.agrid = this;
        l = l || new Array();
        e = e.replace(h, function (n, m, r, o) {
            if (r == "-") {
                r = c.parentNode.idd;
            }
            if (r.indexOf("#") == 0) {
                r = dhtmlx.agrid.getRowId(r.replace("#", ""));
            }
            l[l.length] = [r, o];
            return ('(parseFloat(dhtmlx.agrid.cells("' + r + '",' + o + ").getValue(),10))");
        });
    }
    if (e.indexOf(":") != -1) {
        h = /:(\w+)/g;
        dhtmlx.agrid = this;
        g = c.parentNode.idd;
        l = l || new Array();
        e = e.replace(h, function (n, m, r, o) {
            l[l.length] = [g, dhtmlx.agrid.getColIndexById(m)];
            return ('(parseFloat(dhtmlx.agrid.cells("' +
                g +
                '",dhtmlx.agrid.getColIndexById("' +
                m +
                '")).getValue(),10))');
        });
    }
    else {
        h = /c([0-9]+)/g;
        dhtmlx.agrid = this;
        g = c.parentNode.idd;
        l = l || new Array();
        e = e.replace(h, function (n, m, r, o) {
            l[l.length] = [g, m];
            return ('(parseFloat(dhtmlx.agrid.cells("' + g + '",' + m + ").getValue(),10))");
        });
    }
    this._reLink(l, c);
    c._code = e;
    return this._calcSCL(c);
};
dhtmlXGridObject.prototype._reLink = function (c, a) {
    if (!c.length) {
        return;
    }
    for (var g = 0; g < c.length; g++) {
        if (!this._mat_links[c[g][0]]) {
            this._mat_links[c[g][0]] = {};
        }
        var e = this._mat_links[c[g][0]];
        if (!e[c[g][1]]) {
            e[c[g][1]] = [];
        }
        e[c[g][1]].push(a);
    }
};
if (window._isKHTML) {
    (function () {
        var a = String.prototype.replace;
        String.prototype.replace = function (r, e) {
            if (typeof e != "function") {

                return a.apply(this, arguments);
            }
            var h = "" + this;
            var n = e;
            var m = null;
            if (!(r instanceof RegExp)) {
                m = h.indexOf(r);
                return m == -1 ? h : a.apply(h, [r, n(r, m, h)]);
            }
            var c = r;
            var s = [];
            var l = c.lastIndex;
            var o;
            while ((o = c.exec(h)) != null) {
                m = o.index;
                var g = o.concat(m, h);
                s.push(h.slice(l, m), n.apply(null, g).toString());
                if (!c.global) {
                    l += RegExp.lastMatch.length;
                    break;
                }
                else {
                    l = c.lastIndex;
                }
            }
            s.push(h.slice(l));
            return s.join("");
        };
    })();
}
dhtmlXGridObject.prototype.insertColumn = function (e, n, r, a, m, o, u, c, h) {
    e = parseInt(e);
    if (e > this._cCount) {
        e = this._cCount;
    }
    if (!this._cMod) {
        this._cMod = this._cCount;
    }
    this._processAllArrays(this._cCount, e - 1, [
        n || "&nbsp;",
        a || 100,
        r || "ed",
        o || "left",
        u || "",
        m || "na",
        h || "",
        "",
        this._cMod,
        a || 100
    ]);
    this._processAllRows("_addColInRow", e);
    if (typeof n == "object") {
        for (var l = 1; l < this.hdr.rows.length; l++) {
            if (n[l - 1] == "#rspan") {
                var w = l - 1;
                var v = false;
                var s = null;
                var g = null;
                while (!v) {
                    s = this.hdr.rows[w];
                    for (g = 0; g < s.cells.length; g++) {
                        if (s.cells[g]._cellIndex == e) {
                            v = g;
                            break;
                        }
                    }
                    w--;
                }
                this.hdr.rows[w + 1].cells[g].rowSpan =
                    (this.hdr.rows[w].cells[g].rowSpan || 1) + 1;
            }
            else {
                this.setHeaderCol(e, n[l - 1] || "&nbsp;", l);
            }
        }
    }
    else {
        this.setHeaderCol(e, n || "&nbsp;");
    }
    this.hdr.rows[0].cells[e];
    this._cCount++;
    this._cMod++;
    this._master_row = null;
    this.setSizes();
};
dhtmlXGridObject.prototype.deleteColumn = function (a) {
    a = parseInt(a);
    if (this._cCount == 0) {
        return;
    }
    if (!this._cMod) {
        this._cMod = this._cCount;
    }
    if (a >= this._cCount) {
        return;
    }
    this._processAllArrays(a, this._cCount - 1, [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
    ]);
    this._processAllRows("_deleteColInRow", a);
    this._cCount--;
    this._master_row = null;
    this.setSizes();
};
dhtmlXGridObject.prototype._processAllRows = function (h, a, c) {
    this[h](this.obj.rows[0], a, c, 0);
    var g = this.hdr.rows.length;
    for (var e = 0; e < g; e++) {
        this[h](this.hdr.rows[e], a, c, e);
    }
    if (this.ftr) {
        g = this.ftr.firstChild.rows.length;
        for (var e_2 = 0; e_2 < g; e_2++) {
            this[h](this.ftr.firstChild.rows[e_2], a, c, e_2);
        }
    }
    this.forEachRow(function (l) {

        if (this.rowsAr[l] && this.rowsAr[l].tagName == "TR") {

            this[h](this.rowsAr[l], a, c, -1);
        }
    });
};
dhtmlXGridObject.prototype._processAllArrays = function (r, a, o) {
    var h = [
        "hdrLabels",
        "initCellWidth",
        "cellType",
        "cellAlign",
        "cellVAlign",
        "fldSort",
        "columnColor",
        "_hrrar",
        "_c_order"
    ];
    if (this.cellWidthPX.length) {
        h.push("cellWidthPX");
    }
    if (this.cellWidthPC.length) {
        h.push("cellWidthPC");
    }
    if (this._col_combos) {
        h.push("_col_combos");
    }
    if (this._mCols) {
        h[h.length] = "_mCols";
    }
    if (this.columnIds) {
        h[h.length] = "columnIds";
    }
    if (this._maskArr) {
        h.push("_maskArr");
    }
    if (this._drsclmW) {
        h.push("_drsclmW");
    }
    if (this._RaSeCol) {
        h.push("_RaSeCol");
    }
    if (this._hm_config) {
        h.push("_hm_config");
    }
    if (this._drsclmn) {
        h.push("_drsclmn");
    }
    if (this.clists) {
        h.push("clists");
    }
    if (this._validators && this._validators.data) {
        h.push(this._validators.data);
    }
    h.push("combos");
    if (this._customSorts) {
        h.push("_customSorts");
    }
    if (this._aggregators) {
        h.push("_aggregators");
    }
    var n = r <= a;
    if (!this._c_order) {
        this._c_order = new Array();
        var e = this._cCount;
        for (var m = 0; m < e; m++) {
            this._c_order[m] = m;
        }
    }
    for (var m_1 = 0; m_1 < h.length; m_1++) {
        var s = this[h[m_1]] || h[m_1];
        if (s) {
            if (n) {
                var c = s[r];
                for (var g = r; g < a; g++) {
                    s[g] = s[g + 1];
                }
                s[a] = c;
            }
            else {
                var cVal = s[r];
                for (var g_1 = r; g_1 > a + 1; g_1--) {
                    s[g_1] = s[g_1 - 1];
                }
                s[a + 1] = cVal;
            }
            if (o) {
                s[a + (n ? 0 : 1)] = o[m_1];
            }
        }
    }
};
dhtmlXGridObject.prototype.moveColumn = function (a, c) {
    c--;
    a = parseInt(a);
    c = parseInt(c);
    var e = null;
    if (c < a) {
        e = c + 1;
    }
    else {
        e = c;
    }
    if (!this.callEvent("onBeforeCMove", [a, e])) {
        return false;
    }
    if (a == e) {
        return;
    }
    this.editStop();
    this._processAllRows("_moveColInRow", a, c);
    this._processAllArrays(a, c);
    if (this.fldSorted) {
        this.setSortImgPos(this.fldSorted._cellIndex);
    }
    this.callEvent("onAfterCMove", [a, e]);
};
dhtmlXGridObject.prototype._swapColumns = function (c) {
    var e = new Array();
    for (var a = 0; a < this._cCount; a++) {
        var g = c[this._c_order[a]];
        if (typeof g == "undefined") {
            g = "";
        }
        e[a] = g;
    }
    return e;
};
dhtmlXGridObject.prototype._moveColInRow = function (l, a, e) {
    var m = l.childNodes[a];
    var h = l.childNodes[e + 1];
    if (!m) {
        return;
    }
    if (h) {
        l.insertBefore(m, h);
    }
    else {
        l.appendChild(m);
    }
    for (var g = 0; g < l.childNodes.length; g++) {
        l.childNodes[g]._cellIndex = l.childNodes[g]._cellIndexS = g;
    }
};
dhtmlXGridObject.prototype._addColInRow = function (n, l, a, g) {
    var h = l;
    if (n._childIndexes) {
        if (n._childIndexes[l - 1] == n._childIndexes[l] ||
            !n.childNodes[n._childIndexes[l - 1]]) {
            for (var e = n._childIndexes.length; e >= l; e--) {
                n._childIndexes[e] = e ? n._childIndexes[e - 1] + 1 : 0;
            }
            n._childIndexes[l]--;
        }
        else {
            for (var e_3 = n._childIndexes.length; e_3 >= l; e_3--) {
                n._childIndexes[e_3] = e_3 ? n._childIndexes[e_3 - 1] + 1 : 0;
            }
        }
        h = n._childIndexes[l];
    }
    var o = n.childNodes[h];
    var m = document.createElement(g ? "TD" : "TH");
    if (g) {
        m._attrs = {};
    }
    else {
        m.style.width = (parseInt(this.cellWidthPX[l]) || "100") + "px";
    }
    if (o) {
        n.insertBefore(m, o);
    }
    else {
        n.appendChild(m);
    }
    if (this.dragAndDropOff && n.idd) {
        this.dragger.addDraggableItem(n.childNodes[h], this);
    }
    for (var e_4 = h + 1; e_4 < n.childNodes.length; e_4++) {
        n.childNodes[e_4]._cellIndex = n.childNodes[e_4]._cellIndexS =
            n.childNodes[e_4]._cellIndex + 1;
    }
    if (n.childNodes[h]) {
        n.childNodes[h]._cellIndex = n.childNodes[h]._cellIndexS = l;
    }
    if (n.idd || typeof n.idd != "undefined") {
        this.cells3(n, l).setValue("");
        m.align = this.cellAlign[l];
        m.style.verticalAlign = this.cellVAlign[l];
        m.bgColor = this.columnColor[l];
    }
    else {
        if (m.tagName == "TD") {
            if (!n.idd && this.forceDivInHeader) {
                m.innerHTML = "<div class='hdrcell'>&nbsp;</div>";
            }
            else {
                m.innerHTML = "&nbsp;";
            }
        }
    }
};
dhtmlXGridObject.prototype._deleteColInRow = function (n, m) {
    var e = m;
    if (n._childIndexes) {
        m = n._childIndexes[m];
    }
    var o = n.childNodes[m];
    if (!o) {
        return;
    }
    if (o.colSpan && o.colSpan > 1 && o.parentNode.idd) {
        var h = o.colSpan - 1;
        var a = this.cells4(o).getValue();
        this.setColspan(o.parentNode.idd, o._cellIndex, 1);
        if (h > 1) {
            var l = o._cellIndex * 1;
            this.setColspan(o.parentNode.idd, l + 1, h);
            this.cells(o.parentNode.idd, o._cellIndex * 1 + 1).setValue(a);
            n._childIndexes.splice(l, 1);
            for (var g = l; g < n._childIndexes.length; g++) {
                n._childIndexes[g] -= 1;
            }
        }
    }
    else {
        if (n._childIndexes) {
            n._childIndexes.splice(e, 1);
            for (var g_2 = e; g_2 < n._childIndexes.length; g_2++) {
                n._childIndexes[g_2]--;
            }
        }
    }
    if (o) {
        n.removeChild(o);
    }
    for (var g_3 = m; g_3 < n.childNodes.length; g_3++) {
        n.childNodes[g_3]._cellIndex = n.childNodes[g_3]._cellIndexS =
            n.childNodes[g_3]._cellIndex - 1;
    }
};
dhtmlXGridObject.prototype.enableColumnMove = function (c, a) {
    this._mCol = dhx4.s2b(c);
    if (typeof a != "undefined") {
        this._mCols = a.split(",");
    }
    if (!this._mmevTrue) {
        goingEvent(this.hdr, "mousedown", this._startColumnMove);
        goingEvent(document.body, "mousemove", this._onColumnMove);
        goingEvent(document.body, "mouseup", this._stopColumnMove);
        this._mmevTrue = true;
    }
};
dhtmlXGridObject.prototype._startColumnMove = function (h) {
    h = h || event;
    var g = h.target || h.srcElement;
    var a = g;
    while (a.tagName != "TABLE") {
        a = a.parentNode;
    }
    var c = a.grid;
    if (!c) {
        return;
    }
    c.setActive();
    if (!c._mCol || h.button == 2) {
        return;
    }
    g = c.getFirstParentOfType(g, "TD");
    if (g.style.cursor != "default") {
        return true;
    }
    if (c && !c._colInMove) {
        c.resized = null;
        if (!c._mCols || c._mCols[g._cellIndex] == "true") {
            c._colInMove = g._cellIndex + 1;
        }
    }
    c._colInMovePos = { x: h.clientX, y: h.clientY };
    return true;
};
dhtmlXGridObject.prototype._onColumnMove = function (m) {
    m = m || event;
    var n = null;
    var a = globalObj.globalActiveDHTMLGridObject;
    if (a && a._colInMove) {
        var l = Math.max(Math.abs(m.clientX - a._colInMovePos.x), Math.abs(m.clientY - a._colInMovePos.y));
        if (l < 20) {
            return;
        }
        if (a._hideHContext) {
            a._hideHContext();
        }
        if (typeof a._colInMove != "object") {
            n = document.createElement("DIV");
            n._aIndex = a._colInMove - 1;
            n._bIndex = null;
            n.innerHTML = a.getHeaderCol(n._aIndex);
            n.className = "dhx_dragColDiv";
            n.style.position = "absolute";
            document.body.appendChild(n);
            a._colInMove = n;
        }
        var h = [];
        h[0] = document.body.scrollLeft || document.documentElement.scrollLeft;
        h[1] = document.body.scrollTop || document.documentElement.scrollTop;
        a._colInMove.style.left = m.clientX + h[0] + 8 + "px";
        a._colInMove.style.top = m.clientY + h[1] + 8 + "px";
        var c = m.target || m.srcElement;
        while (c && typeof c._cellIndexS == "undefined") {
            c = c.parentNode;
        }
        if (a._colInMove._oldHe) {
            a._colInMove._oldHe.className = a._colInMove._oldHe.className.replace(/columnTarget(L|R)/g, "");
            a._colInMove._oldHe = null;
            a._colInMove._bIndex = null;
        }
        if (c) {
            var g = null;
            if (a.hdr.rows[1]._childIndexes) {
                g = a.hdr.rows[1].cells[a.hdr.rows[1]._childIndexes[c._cellIndexS]];
            }
            else {
                g = a.hdr.rows[1].cells[c._cellIndexS];
            }
            n = m.clientX - (dhx4.absLeft(g) - a.hdrBox.scrollLeft);
            if (n / g.offsetWidth > 0.5) {
                g.className += " columnTargetR";
                a._colInMove._bIndex = c._cellIndexS;
            }
            else {
                g.className += " columnTargetL";
                a._colInMove._bIndex = c._cellIndexS - 1;
            }
            if (g.offsetLeft < a.objBox.scrollLeft + 20) {
                a.objBox.scrollLeft = Math.max(0, g.offsetLeft - 20);
            }
            if (g.offsetLeft + g.offsetWidth - a.objBox.scrollLeft >
                a.objBox.offsetWidth - 20) {
                a.objBox.scrollLeft = Math.min(a.objBox.scrollLeft + g.offsetWidth + 20, a.objBox.scrollWidth - a.objBox.offsetWidth);
            }
            a._colInMove._oldHe = g;
        }
        m.cancelBubble = true;
        return false;
    }
    return true;
};
dhtmlXGridObject.prototype._stopColumnMove = function () {
    c = c || event;
    var a = globalObj.globalActiveDHTMLGridObject;
    if (a && a._colInMove) {
        if (typeof a._colInMove == "object") {
            a._colInMove.parentNode.removeChild(a._colInMove);
            if (a._colInMove._bIndex != null) {
                a.moveColumn(a._colInMove._aIndex, a._colInMove._bIndex + 1);
            }
            if (a._colInMove._oldHe) {
                a._colInMove._oldHe.className = a._colInMove._oldHe.className.replace(/columnTarget(L|R)/g, "");
            }
            a._colInMove._oldHe = null;
            a._colInMove.grid = null;
            a.resized = true;
        }
        a._colInMove = 0;
    }
    return true;
};
dhtmlXGridObject.prototype.mouseOverHeader = function (c) {
    var a = this;
    goingEvent(this.hdr, "mousemove", function (h) {
        h = h || window.event;
        var g = h.target || h.srcElement;
        if (g.tagName != "TD") {
            g = a.getFirstParentOfType(g, "TD");
        }
        if (g && typeof g._cellIndex != "undefined") {
            c(g.parentNode.rowIndex, g._cellIndex);
        }
    });
};
dhtmlXGridObject.prototype.mouseOver = function (c) {
    var a = this;
    goingEvent(this.obj, "mousemove", function (h) {
        h = h || window.event;
        var g = h.target || h.srcElement;
        if (g.tagName != "TD") {
            g = a.getFirstParentOfType(g, "TD");
        }
        if (g && typeof g._cellIndex != "undefined") {
            c(g.parentNode.rowIndex, g._cellIndex);
        }
    });
};
dhtmlXGridObject.prototype.enablePaging = function (l, g, c, h, a, e) {
    this._pgn_parentObj = typeof h == "string" ? document.getElementById(h) : h;
    this._pgn_recInfoParentObj =
        typeof e == "string" ? document.getElementById(e) : e;
    this.pagingOn = l;
    this.showRecInfo = a;
    this.rowsBufferOutSize = parseInt(g);
    this.currentPage = 1;
    this.pagesInGroup = parseInt(c);
    this._init_pgn_events();
    this.setPagingSkin("default");
};
dhtmlXGridObject.prototype.setXMLAutoLoading = function (a, c) {
    this.xmlFileUrl = a;
    this._dpref = c;
};
dhtmlXGridObject.prototype.changePageRelative = function (a) {
    this.changePage(this.currentPage + a);
};
dhtmlXGridObject.prototype.changePage = function (a) {
    if (arguments.length == 0) {
        a = this.currentPage || 0;
    }
    a = parseInt(a);
    a = Math.max(1, Math.min(a, Math.ceil(this.rowsBuffer.length / this.rowsBufferOutSize)));
    if (!this.callEvent("onBeforePageChanged", [this.currentPage, a])) {
        return;
    }
    this.currentPage = parseInt(a);
    this._reset_view();
    this._fixAlterCss();
    this.callEvent("onPageChanged", this.getStateOfView());
};
dhtmlXGridObject.prototype.setPagingSkin = function (a) {
    this._pgn_skin = this["_pgn_" + a];
    if (a == "toolbar") {
        this._pgn_skin_tlb = arguments[1];
    }
};
dhtmlXGridObject.prototype.setPagingTemplates = function (e, c) {
    this._pgn_templateA = this._pgn_template_compile(e);
    this._pgn_templateB = this._pgn_template_compile(c);
    this._page_skin_update();
};
dhtmlXGridObject.prototype._page_skin_update = function (a) {
    if (!this.pagesInGroup) {
        this.pagesInGroup = Math.ceil(Math.min(5, this.rowsBuffer.length / this.rowsBufferOutSize));
    }
    var c = Math.ceil(this.rowsBuffer.length / this.rowsBufferOutSize);
    if (c && c < this.currentPage) {
        return this.changePage(c);
    }
    if (this.pagingOn && this._pgn_skin) {
        this._pgn_skin.apply(this, this.getStateOfView());
    }
};
dhtmlXGridObject.prototype._init_pgn_events = function (a) {
    this.attachEvent("onXLE", this._page_skin_update);
    this.attachEvent("onClearAll", this._page_skin_update);
    this.attachEvent("onPageChanged", this._page_skin_update);
    this.attachEvent("onGridReconstructed", this._page_skin_update);
    this._init_pgn_events = function () { };
};
dhtmlXGridObject.prototype._pgn_default = function (e, g, a) {
    if (!this.pagingBlock) {
        this.pagingBlock = document.createElement("DIV");
        this.pagingBlock.className = "pagingBlock";
        this.recordInfoBlock = document.createElement("SPAN");
        this.recordInfoBlock.className = "recordsInfoBlock";
        if (!this._pgn_parentObj) {
            return;
        }
        this._pgn_parentObj.appendChild(this.pagingBlock);
        if (this._pgn_recInfoParentObj && this.showRecInfo) {
            this._pgn_recInfoParentObj.appendChild(this.recordInfoBlock);
        }
        if (!this._pgn_templateA) {
            this._pgn_templateA = this._pgn_template_compile("[prevpages:&lt;:&nbsp;] [currentpages:,&nbsp;] [nextpages:&gt;:&nbsp;]");
            this._pgn_templateB = this._pgn_template_compile("Results <b>[from]-[to]</b> of <b>[total]</b>");
        }
    }
    var c = this.getStateOfView();
    this.pagingBlock.innerHTML = this._pgn_templateA.apply(this, c);
    this.recordInfoBlock.innerHTML = this._pgn_templateB.apply(this, c);
    this._pgn_template_active(this.pagingBlock);
    this._pgn_template_active(this.recordInfoBlock);
    this.callEvent("onPaging", []);
};
dhtmlXGridObject.prototype._pgn_block = function (c) {
    var h = Math.floor((this.currentPage - 1) / this.pagesInGroup) * this.pagesInGroup;
    var a = Math.min(Math.ceil(this.rowsBuffer.length / this.rowsBufferOutSize), h + this.pagesInGroup);
    var g = [];
    for (var e = h + 1; e <= a; e++) {
        if (e == this.currentPage) {
            g.push("<a class='dhx_not_active'><b>" + e + "</b></a>");
        }
        else {
            g.push("<a onclick='this.grid.changePage(" +
                e +
                "); return false;'>" +
                e +
                "</a>");
        }
    }
    return g.join(c);
};
dhtmlXGridObject.prototype._pgn_link = function (g, c, e) {
    if (g == "prevpages" || g == "prev") {
        if (this.currentPage == 1) {
            return e;
        }
        return ("<a onclick='this.grid.changePageRelative(-1*" +
            (g == "prev" ? "1" : "this.grid.pagesInGroup") +
            "); return false;'>" +
            c +
            "</a>");
    }
    if (g == "nextpages" || g == "next") {
        if (this.rowsBuffer.length / this.rowsBufferOutSize <= this.currentPage) {
            return e;
        }
        if (this.rowsBuffer.length /
            (this.rowsBufferOutSize * (g == "next" ? "1" : this.pagesInGroup)) <=
            1) {
            return e;
        }
        return ("<a onclick='this.grid.changePageRelative(" +
            (g == "next" ? "1" : "this.grid.pagesInGroup") +
            "); return false;'>" +
            c +
            "</a>");
    }
    if (g == "current") {
        var a = this.currentPage + (c ? parseInt(c) : 0);
        if (a < 1 ||
            Math.ceil(this.rowsBuffer.length / this.rowsBufferOutSize) < a) {
            return e;
        }
        return ("<a " +
            (a == this.currentPage ? "class='dhx_active_page_link' " : "") +
            "onclick='this.grid.changePage(" +
            a +
            "); return false;'>" +
            a +
            "</a>");
    }
    return c;
};
dhtmlXGridObject.prototype._pgn_template_active = function (e) {
    var a = e.getElementsByTagName("A");
    if (a) {
        for (var c = 0; c < a.length; c++) {
            a[c].grid = this;
        }
    }
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dxGridMethods1.js